export const container = `rounded text-xs font-medium bg-gray-400 text-base-white h-5 flex items-center justify-center w-16 shrink-0`;
